import { CheckIcon } from '@heroicons/react/24/outline';
import { Reveal } from '../motion';
import { PrimaryButton, QuietButton } from '../components/Buttons';
import { FREE_FEATURES, PREMIUM_FEATURES, PREMIUM_PRICE } from '../../config/plans';

const FREE = FREE_FEATURES;
const PREMIUM = PREMIUM_FEATURES;

function Plan({ name, price, note, features, highlight, cta }) {
  return (
    <div className={`pn-bezel h-full ${highlight ? 'shadow-[inset_0_0_0_1px_rgb(var(--pn-signal)/0.45)]' : ''}`}>
      <div className="pn-plate flex h-full flex-col p-[clamp(1.4rem,0.9rem+1.6*var(--u),2.5rem)]">
        <h3 className="pn-h3">{name}</h3>
        <p className="mt-6 flex items-baseline gap-2">
          <span className="pn-num text-[clamp(2.4rem,1.2rem+3.4*var(--u),4rem)] font-bold leading-none">{price}</span>
          <span className="text-pn-muted">{note}</span>
        </p>
        <ul className="mt-8 flex-1 space-y-3">
          {features.map(f => (
            <li key={f} className="flex gap-3">
              <CheckIcon className={`mt-0.5 h-5 w-5 shrink-0 ${highlight ? 'text-pn-signal' : 'text-pn-muted'}`} strokeWidth={2} />
              <span>{f}</span>
            </li>
          ))}
        </ul>
        <div className="mt-10">{cta}</div>
      </div>
    </div>
  );
}

export default function Pricing({ onStart, onTrial }) {
  return (
    <section id="pricing" aria-label="Pricing" className="mx-auto max-w-[1480px] px-4 py-24 sm:px-6 tall:px-12 land:py-36">
      <Reveal>
        <h2 className="pn-h2 max-w-[14ch]">Free to start. One upgrade.</h2>
        <p className="pn-lede mt-4">Try Premium free for 14 days. No credit card required.</p>
      </Reveal>
      <div className="mt-12 grid gap-4 md:grid-cols-2">
        <Reveal>
          <Plan
            name="Free"
            price="$0"
            note="forever"
            features={FREE}
            cta={<QuietButton onClick={onStart}>Start free</QuietButton>}
          />
        </Reveal>
        <Reveal delay={0.1}>
          <Plan
            name="Premium"
            price={`$${PREMIUM_PRICE}`}
            note="paid once"
            features={PREMIUM}
            highlight
            cta={<PrimaryButton onClick={onTrial}>Try 14 days free</PrimaryButton>}
          />
        </Reveal>
      </div>
    </section>
  );
}
